import React, { useState } from "react";
import LeftDrawer from "../../../components/drawer/LeftDrawer";
import { DrawerStyled } from "./drawerStyled";
import DrawerContent from "./drawer-content";

const Drawer = ({
  project,
  resources,
  setResources,
  deliverables,
  setDeliverables,
  loggedRolesList,
  company,
  rateOption,
  onRateOptionChange,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <DrawerStyled expanded={expanded}>
      <LeftDrawer
        label={"Project Resources"}
        expanded={expanded}
        setExpanded={setExpanded}
        expandedContent={
          <DrawerContent
            isCollapsed={false}
            project={project}
            company={company}
            resources={resources}
            setResources={setResources}
            deliverables={deliverables}
            setDeliverables={setDeliverables}
            loggedRolesList={loggedRolesList}
            rateOption={rateOption}
            onRateOptionChange={onRateOptionChange}
          />
        }
        collapsedContent={
          <DrawerContent
            isCollapsed={true}
            project={project}
            company={company}
            resources={resources}
            setResources={setResources}
            deliverables={deliverables}
            setDeliverables={setDeliverables}
            loggedRolesList={loggedRolesList}
            rateOption={rateOption}
            onRateOptionChange={onRateOptionChange}
          />
        }
      />
    </DrawerStyled>
  );
};

export default Drawer;
